export const ALWAYS_ALLOWED_ROUTES = ["/session-expired"];

export const DEFINED_ROUTES = [
  "/dashboard",
  "/users",
  "/order-activity",
  "/configuration",
  "/ltlCustomers",
  "/invoice-activity",
  "/tender-acceptance",
  "/settings",
  "/piaggioCustomers",
  "/lozierStore",
  "/ecolabItems",
  "/pod-upload-activity",
  "/cardtronicsCustomers",
  "/hpeCustomers",
  "/calixNetworksCustomers",
  "/nautilusItems",
  "/settings-new",
  "carrier-tracking-activity",
];
